<div class="container-fluid content-wrapper">
  <h1 class="page-title">
    <img src="assets/svg/read-kid.svg" height="130px" class="logo-title" />
    Email Makeover
    <img src="assets/svg/flask.svg" height="70px" class="logo-title" />
  </h1>

  <button class="btn-baby-bigal polish-button" (click)="openDescriptionDialog()">
    <span class="polish-levels-text">Polish Levels - Edit Descriptions </span>
  </button>
  <div class="content">
    <br>
    <p class="word-counter">Paste In Email And Use The Dropdown To Polish Your Email</p>

    <!-- Personality-style textarea -->
    <div class="content-buttons col-12">
      <textarea
        id="inputText"
        [(ngModel)]="inputText"
        placeholder="Email To Be Polished..."
        [disabled]="isLoading"
        rows="6"
        class="bottom-room"
        style="width: 100%;"
      ></textarea>
    </div>

    <!-- Personality-style submit button -->
    <div class="content-buttons col-12">
      <button
        (click)="onSubmit()"
        class="btn-baby-bigal"
        [class.w-100]="true"
        [disabled]="isLoading">
        {{ isLoading ? 'Processing...' : 'Submit' }}
      </button>
    </div>

    <br>
    <div class="upload-section">
      <label class="ali-label"><br><br></label>
      <select [(ngModel)]="selectedReadingLevel" class="styled-dropdown" (change)="onReadingLevelSelected()">
        <option *ngFor="let level of [1,2,3,4]" [value]="level">
          Level  {{ level }} Polish
        </option>
      </select>
    </div>

    <br>
    <!-- Thinking Loading Animation -->
    <app-bird-loader *ngIf="isLoading" label="Thinking"></app-bird-loader>

    <!-- <div *ngIf="isLoading" class="loading">Generating Your Description...</div> -->

    <mat-tab-group #tabGroup [selectedIndex]="0">
      <mat-tab label="Business Audience">
        <ng-container *ngIf="transformedTess">
          <div class="images-grid">
            <div class="image-item">
              <img src="assets/svg/book-love.svg" height="20px;" alt="Uploaded Image" />
              <!-- Render formatted transformed text using Showdown -->
              <div [innerHTML]="formattedPlan"></div>

              <button class="btn-red-bigal" (click)="exportToPDF()">
                Export to PDF
              </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="btn-red-bigal" (click)="exportToDocs">
                Export to DOCX
              </button>
            </div>
          </div>
        </ng-container>
      </mat-tab>

      <mat-tab label="Academic Audience">
        <ng-container *ngIf="transformedText">
          <div class="images-grid">
            <div class="image-item">
              <img src="assets/svg/book-love.svg" height="20px;" alt="Uploaded Image" />
              <!-- Render formatted transformed text using Showdown -->
              <div [innerHTML]="formattedText"></div>

              <button class="btn-red-bigal" (click)="exportToPDF()">
                Export to PDF
              </button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <button class="btn-red-bigal" (click)="exportToDocs()">
                Export to DOCX
              </button>
            </div>
          </div>
        </ng-container>
      </mat-tab>
    </mat-tab-group>

    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
  </div>
</div>
